import { ShoppingCart, X, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';
import { DrawerTitle } from './ui/drawer';

export default function CartDrawer({ onClose }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-4 pt-4">
        <div className="flex items-center gap-2">
          <ShoppingCart className="h-5 w-5 text-foreground" />
          <DrawerTitle>Shopping Cart</DrawerTitle>
        </div>
        <Button variant="ghost" size="sm" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-4 py-8">
        <ShoppingBag className="h-16 w-16 text-muted-foreground mb-4" />
        <p className="text-center text-muted-foreground">
          Your cart is empty.
        </p>
        <p className="text-center text-sm text-muted-foreground mt-2">
          Start shopping to add items!
        </p>
      </div>

      <div className="px-4 py-4 border-t border-border">
        <Button className="w-full bg-foreground text-background hover:bg-muted" disabled>
          Checkout
        </Button>
      </div>
    </div>
  );
}